(function() {
'use strict';

const header = document.querySelector("#shopify-section-header");
let headerFixFrame = 0;

document.addEventListener("scroll", () => {
    if (!header || headerFixFrame) return;
    headerFixFrame = requestAnimationFrame(() => {
        headerFixFrame = 0;
        const stuck = window.scrollY > 20;
        header.classList.toggle("pf-header-fix", stuck);
        const navigationBarPDP = document.querySelector("#sticky-navigation-pdp");
        if (navigationBarPDP) {
            navigationBarPDP.classList.toggle("pf-header-fix", stuck);
        }
    });
}, { passive: true });

function BlockScroll() {
    document.querySelector("html").classList.add("scroll-block");
}

function AllowScroll() {

    document.querySelector("html").classList.remove("scroll-block");

}

const menuObserver = new MutationObserver(() => {
    const body = document.querySelector("body");
    if (body.classList.contains("nav-active")) {
        BlockScroll();
    } else {
        AllowScroll();
    }
});

const cartObserver = new MutationObserver(() => {
    const cart = document.querySelector(".rc90");
    if (!cart) return;
    if (cart.classList.contains("rc90--open")) {
        BlockScroll();
    } else {
        AllowScroll();
    }
});

const cart = document.querySelector(".rc90");
if (cart) {
    cartObserver.observe(cart, {
        attributes: true,
        attributeFilter: ["class"],
    });
}

const body = document.querySelector("body");
if (body) {
    menuObserver.observe(body, {
        attributes: true,
        attributeFilter: ["class"],
    });
}

})();
